<template>
  <thead>
    <th>
      {{ I18n.t("table.number") }}
    </th>
    <th
      v-for="(columnName, index) in columnNames"
      :key="index"
    >
      {{ I18n.t(`artworks.${columnName}`) }}
    </th>
  </thead>
</template>

<script>
  export default {
    name: 'MainTableHead',
    data() {
      return {
        columnNames: [
          'catalog_number_short',
          'image',
          'author',
          'title_and_year',
          'starting_price_without_currency',
          'estimated_price',
          'highest_offer',
        ],
      };
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/table/main_table_head.vue?08ed8175